export const defaultDictionary = {
  "common.menu": "Menu",
} as { [x: string]: string };
